"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_DSN = 'https://8bc29fb6cd064a49a9945743de020bf2@sentry.io/1186457';
